import React, { useEffect } from "react";
import { Menu } from "antd";
import MainServices from "../../services/Main.services";

const items = [
    {
        label: "ONE Knowledge",
        key: 25
    },
    {
        label: "ONE Intelligence",
        key: 3
    },
    {
        label: "ONE Insight",
        key: 28
    },
    {
        label: "ONE Audience",
        key: 2
    },
    {
        label: "ONE Market DSP",
        key: 8
    }
];

const AppMenu = function () {
    // functions
    const handleActiveNav = ({ key }) => {
        const { appList } = MainServices.userDetails();
        const foundPermission = (appList || []).find(({ id }) => id === parseInt(key));
        if (!foundPermission) {
            window.location.reload();
            return;
        }
        try {
            if (window.whiteLabelType === "pvblicone") {
                const { origin, pathname } = new URL(foundPermission?.url);
                const isOM = origin.includes("onemarket.sqreemtech");
                let folderName = "pVblicOne";
                if (isOM) {
                    folderName = folderName.toLocaleLowerCase()
                }
                window.open(`${origin}/${folderName}${pathname}`);
            } else {
                window.open(foundPermission?.url);
            }
        } catch (error) {

        }
    };

    return (
        <Menu
            style={{
                width: "100%",
                background: "#303e53"
            }}
            className="custom_menu"
            theme="dark"
            mode="horizontal"
            onClick={handleActiveNav}
            selectedKeys={["3"]}
        >
            {items.map((d) => {
                const { appDetails, appList } = MainServices.userDetails();
                const foundPermission = [...(appDetails ? [appDetails] : []), ...(appList || [])].find(({ id }) => id === d.key)
                if (!foundPermission) return null
                return <Menu.Item key={d.key}>{d.label}</Menu.Item>
            })}
        </Menu>
    );
};
export default AppMenu;
